/* =========================================================
   PlayOn Padel — product page interactions (no dependencies)
   Safe to load on both the static preview and the Shopify theme.
   Every handler guards for missing elements so it never throws.
   ========================================================= */
(function () {
  "use strict";

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
    /* ---------- Gallery ---------- */
    (function gallery() {
      var root = document.querySelector("[data-gallery]");
      if (!root) return;
      var images = Array.prototype.slice.call(root.querySelectorAll("[data-gallery-img]"));
      var thumbs = Array.prototype.slice.call(document.querySelectorAll("[data-gallery-thumb]"));
      if (!images.length) return;
      var index = 0;

      function show(i) {
        index = (i + images.length) % images.length;
        images.forEach(function (img, n) { img.classList.toggle("is-active", n === index); });
        thumbs.forEach(function (t, n) { t.classList.toggle("is-active", n === index); });
      }
      thumbs.forEach(function (t, n) {
        t.addEventListener("click", function () { show(n); });
      });
      var prev = root.querySelector("[data-gallery-prev]");
      var next = root.querySelector("[data-gallery-next]");
      if (prev) prev.addEventListener("click", function () { show(index - 1); });
      if (next) next.addEventListener("click", function () { show(index + 1); });
      show(0);
    })();

    /* ---------- Accordions (info + FAQ) ---------- */
    (function accordions() {
      var buttons = document.querySelectorAll("[data-acc-btn]");
      buttons.forEach(function (btn) {
        var panel = btn.parentElement.querySelector("[data-acc-panel]");
        if (!panel) return;
        // start collapsed unless flagged open
        var startOpen = btn.getAttribute("data-acc-open") === "true";
        btn.setAttribute("aria-expanded", startOpen ? "true" : "false");
        if (startOpen) panel.style.maxHeight = panel.scrollHeight + "px";

        btn.addEventListener("click", function () {
          var isOpen = btn.getAttribute("aria-expanded") === "true";
          btn.setAttribute("aria-expanded", isOpen ? "false" : "true");
          panel.style.maxHeight = isOpen ? "0px" : panel.scrollHeight + "px";
        });
      });
      // keep open panels sized correctly on resize
      window.addEventListener("resize", function () {
        document.querySelectorAll('[data-acc-btn][aria-expanded="true"]').forEach(function (btn) {
          var panel = btn.parentElement.querySelector("[data-acc-panel]");
          if (panel) panel.style.maxHeight = panel.scrollHeight + "px";
        });
      });
    })();

    /* ---------- Size selector + variant binding ---------- */
    (function sizeSelector() {
      var opts = Array.prototype.slice.call(document.querySelectorAll("[data-size-opt]"));
      if (!opts.length) return;
      var variantInput = document.querySelector("[data-variant-id]"); // present only on Shopify
      var priceNow = document.querySelector("[data-price-now]");

      function select(opt) {
        opts.forEach(function (o) { o.classList.remove("is-active"); });
        opt.classList.add("is-active");
        if (variantInput && opt.getAttribute("data-variant")) {
          variantInput.value = opt.getAttribute("data-variant");
        }
        if (priceNow && opt.getAttribute("data-price")) {
          priceNow.textContent = opt.getAttribute("data-price");
        }
      }
      opts.forEach(function (opt) {
        opt.addEventListener("click", function () { select(opt); });
      });
      // preselect first available
      var pre = opts.filter(function (o) { return o.getAttribute("data-selected") === "true"; })[0] || opts[0];
      select(pre);
    })();

    /* ---------- Count-up stats (fixes the "0%" bug) ---------- */
    (function stats() {
      var nums = Array.prototype.slice.call(document.querySelectorAll("[data-count]"));
      if (!nums.length) return;

      function animate(el) {
        var target = parseFloat(el.getAttribute("data-count"));
        if (isNaN(target)) { return; }
        var suffix = el.getAttribute("data-suffix") || "";
        var dur = 1400, start = null;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          var val = Math.round(target * eased);
          el.innerHTML = val + (suffix ? '<span class="po-unit">' + suffix + "</span>" : "");
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }

      // Fallback: if IntersectionObserver missing, just set final values immediately.
      if (!("IntersectionObserver" in window)) {
        nums.forEach(function (el) {
          var suffix = el.getAttribute("data-suffix") || "";
          el.innerHTML = el.getAttribute("data-count") + (suffix ? '<span class="po-unit">' + suffix + "</span>" : "");
        });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animate(entry.target);
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.4 });
      nums.forEach(function (el) { io.observe(el); });
    })();

    /* ---------- Sticky mobile ATC ---------- */
    (function stickyAtc() {
      var bar = document.querySelector("[data-sticky]");
      var anchor = document.querySelector("[data-atc-anchor]");
      if (!bar || !anchor) return;
      if (!("IntersectionObserver" in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          // show sticky once the main ATC has scrolled out of view
          bar.classList.toggle("is-visible", !e.isIntersecting && e.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      io.observe(anchor);
    })();

    /* ---------- Cart count (preview only; Shopify form posts for real) ---------- */
    (function previewCart() {
      var forms = document.querySelectorAll("[data-preview-cart]");
      var countEl = document.querySelector("[data-cart-count]");
      if (!forms.length || !countEl) return;
      var count = 0;
      forms.forEach(function (form) {
        form.addEventListener("submit", function (e) {
          e.preventDefault();
          count += 1;
          countEl.textContent = count;
          var btn = form.querySelector(".po-btn");
          if (btn) {
            var original = btn.getAttribute("data-label") || btn.textContent;
            btn.textContent = "Added \u2713";
            setTimeout(function () { btn.textContent = original; }, 1400);
          }
        });
      });
    })();

    /* ---------- Smooth-scroll the in-page CTA buttons to the buy box ---------- */
    (function scrollCta() {
      document.querySelectorAll('[data-scroll-to]').forEach(function (link) {
        link.addEventListener("click", function (e) {
          var sel = link.getAttribute("data-scroll-to");
          var target = document.querySelector(sel);
          if (target) {
            e.preventDefault();
            target.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        });
      });
    })();
  });
})();
